<app-current-saloon-actions></app-current-saloon-actions>
<div class="nav-container">
  <div class="buttons-container">
    @for (item of navItems; track item.route) {
    <div class="nav-item">
      <button type="button" [routerLink]="[item.route]" [class.active]="isActive(item.route)">
        <img [src]="item.icon" [alt]="item.alt" />
        <span class="nav-label">{{ item.label }}</span>
      </button>
      @if (item.route === '/chat' && unreadCount > 0) {
      <span class="unread-badge">{{ unreadCount > 99 ? '99+' : unreadCount }}</span>
      }
    </div>
    }
  </div>
</div>
